<template>
  <AppBanner
    v-if="showPromotion"
    v-bind="$props"
    @close="close"
  >
    <template #primaryCta>
      <button
        class="btn primary-cta"
        :class="promotionType === 'dialog' ? 'btn-primary' : 'btn-sm'"
        @click="ctaClicked"
      >
        {{ primaryCtaText }}
      </button>
    </template>
  </AppBanner>
</template>

<script>
import AppBanner from '../AppBanner.vue';

export default {
  name: 'ScheduledReportsPromotionFeatureBanner',
  components: {
    AppBanner,
  },
  extends: AppBanner,
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    primaryCtaText() {
      return this.bannerProps.primaryCta.text;
    },
    showPromotion() {
      if (this.promotionType === 'dialog') {
        return this.showDialog;
      }

      return true;
    },
  },
  methods: {
    ctaClicked() {
      if (this.promotionType === 'dialog') {
        this.$emit('close', 'scheduledReportBannerDialog');
      }

      this.$emit('open-dialog', 'scheduledReport');
      this.trackCtaClicked();
    },
    close() {
      if (this.promotionType === 'dialog') {
        this.$emit('close', 'scheduledReportBannerDialog');
      }
    },
  },
};
</script>
